module.exports = __webpack_public_path__ + "img/h-3.68b33c8f.png";